<template>
  <div>
    <label class="d-block">
      {{ $t(config.label) }}
    </label>
    <validation-provider
      :name="fieldType"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <v-select
        :options="users"
        v-model="model"
        :clearable="false"
        :reduce="(val) => val[fieldParam]"
        input-id="id_unit"
        :multiple="(multiple || multiple === 1)"
        @input="$emit('input', model)"
      />
      <p class="mb-0 small">{{ hint }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider } from "vee-validate";
import store from "@/store";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Number | Boolean,
    config: Object,
    context: Object,
  },
  data() {
    return {
      model: null,
    };
  },
  created() {
    this.model = this.value;
  },
  mounted() {
    if (!this.users.length) {
      store.dispatch("user/getAll");
    }
  },
  computed: {
    users() {
      return store.getters["user/getSelectedItems"];
    },
    fieldType() {
      if (this.config.label.indexOf('helpdesk') >= 0) {
        return this.$t(`commands.data_types.${this.config.name}`);
      }

      this.config.label;
    },
    label() {
      if (this.config.label.indexOf('helpdesk') >= 0) {
        return this.$t(`commands.form.${this.config.label}.label`);
      }

      this.config.label;
    },
    hint() {
      if (this.config.label.indexOf('helpdesk') >= 0) {
        return this.$t(`commands.form.${this.config.label}.hint`);
      }

      this.config.label;
    },
    fieldParam() {
      if (this.config.data && this.config.data.field) {
        return this.config.data.field === 'email' ? 'label' : this.config.data.field;
      }

      return 'value';
    }
  },
};
</script>

<style></style>
